export const AUB_VIDEO_URL = 'https://advocats.s3.amazonaws.com/minerva_ident_short_final.mp4';